import { z } from 'zod';
/** Current document version users must accept. Bumping this number forces
 *  every existing user to accept again on next login. */
export const CURRENT_CONSENT_VERSION = '06.05.2026';
export const consentStatusSchema = z.object({
    accepted: z.boolean(),
    version: z.string(),
    acceptedAt: z.string().nullable(),
});
export const acceptConsentSchema = z.object({
    version: z.string().min(1),
});
